import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function HomeFeatured() {
  const featured = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
              热门攻略推荐
            </h2>
            <p className="text-sm text-foreground-600">
              精选撸啊撸攻略文章，助你快速提升游戏水平
            </p>
          </div>
          <Link
            to="/category/hero-guide"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium no-underline transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    热门
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime} 分钟
                  </span>
                  <span>{article.publishDate}</span>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-2 mt-4">
                  {article.tags.slice(0, 3).map((tag: string) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}